import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';
import Toggle from '../Common/Toggle/Toggle';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import Button from '../Common/Button';
import './AdminProfileForm.scss';

export default class AdminProfileForm extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onFormChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onRoleChange = (roleId) => {
        this.props.onFormChange("roleId", roleId);
    }

    onActiveChanged = (name, value) => {
        this.props.onFormChange(name, value);
    }

    render() {
        return (
            <div className="admin-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                    {
                        this.props.user.id > 0 && this.props.user.userName.trim().length > 0
                            ?
                            <div className="button-wrapper">
                                <Button className="forgot-password-button" type="button" bootstrapClass="primary" text="Send Forgot Password Email" onClick={this.props.sendForgotPasswordEmail} />
                            </div>
                            :
                            ''
                    }
                    <InputText name="firstName" label="First Name" placeholder="First Name" type="text" value={this.props.user.firstName} onChange={this.onFormChange} isRequired={true} errorMessage="First Name is required" />
                    <InputText name="lastName" label="Last Name" placeholder="Last Name" type="text" value={this.props.user.lastName} onChange={this.onFormChange} isRequired={true} errorMessage="Last Name is required" />
                    <InputText name="userName" label="UserName" placeholder="UserName" type="text" value={this.props.user.userName} onChange={this.onFormChange} isRequired={true} errorMessage="UserName is required" />
                    <InputText name="email" label="Email" placeholder="Email" type="text" value={this.props.user.email} onChange={this.onFormChange} isRequired={true} errorMessage="Email is required" />
                    <MultiSelectBox name="roleId" label="Role" idField="id" valueField="name"
                        options={this.props.adminRoles}
                        onChange={this.onRoleChange}
                        selectedValues={this.props.user.roleId.toString()}
                        isRequired={true}
                        errorMessage="Role is required"
                        isMulti={false}
                    />
                    {
                        // Don't show Active toggle when creating a new user or when editing yourself,
                        !this.props.user.id > 0 || this.props.user.id === this.props.loggedInUserId ?
                            '' :
                            <Toggle name="isActive" text="Active" checked={this.props.user.isActive} onChange={this.onActiveChanged} />
                    }
                </form>
            </div>
        );
    }
}

AdminProfileForm.propTypes = {
    isFormValid: PropTypes.bool.isRequired,
    loggedInUserId: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired,
    adminRoles: PropTypes.array.isRequired,
    sendForgotPasswordEmail: PropTypes.func.isRequired,
    onFormChange: PropTypes.func.isRequired
}
